module.exports = __webpack_public_path__ + "static/media/Residential_30.1920679d.jpg";